import './NewPatientPage.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BackLink from '@components/BackLink';
import BottomBar from '@components/BottomBar';
import {
  Form,
  FormDateField,
  FormMaskField,
  FormSection,
  FormSelectField,
  FormSubmitButton,
  FormTextField,
  FormToggleField,
} from '@components/Form';
import { useInjection } from '@components/Injection';
import Layout from '@components/Layout';
import { RoutePath } from '@constants/route-path';
import { IPatient, patientValidationSchema } from '@models/patient';
import { IPatientsService, PATIENTS_SERVICE } from '@src/services';

const initialValues: IPatient = {
  clinicId: 0, // TODO:  Change this when logging and state management has been implemented
  firstName: '',
  lastName: '',
  email: '',
  dateOfBirth: null,
  phoneNumber: '',
  hasNoHealthInsurance: true,
  insuranceInfo: { insuranceNumber: '', companyName: '' },
};

function NewPatientPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const patientsService = useInjection<IPatientsService>(PATIENTS_SERVICE);

  const createPatient = async (patient: IPatient) => {
    await patientsService.create(patient);
    navigate(RoutePath.PatientListPage);
  };

  return (
    <Layout noFooter>
      <BackLink to={RoutePath.PatientListPage}>Patient list</BackLink>
      <h1 className="modTitle modTitle--h1">{t('newPatient.title')}</h1>
      <Form initialValues={initialValues} validationSchema={patientValidationSchema} onSubmit={createPatient}>
        {({ values }) => (
          <>
            <FormSection title={t('newPatient.patientInfo')}>
              <FormTextField name="firstName" label={t('models.patient.firstName')} placeholder="John" />
              <FormTextField name="lastName" label={t('models.patient.lastName')} placeholder="Doe" />
              <FormDateField name="dateOfBirth" label={t('models.patient.dateOfBirth')} size={100} />
              <FormTextField
                name="email"
                label={t('models.patient.email')}
                placeholder="johndoe@modulate.com"
                size={100}
                optional
              />
              <FormMaskField
                name="phoneNumber"
                label={t('models.patient.phoneNumber')}
                mask="___ ___-____"
                replacement={{ _: /\d/ }}
                size={100}
                optional
              />
              {/*              <FormToggleField
                name="hasNoHealthInsurance"
                label={t('models.patient.hasNoHealthInsurance')}
                size={100}
              />
              {!values.hasNoHealthInsurance && (
                <div className="modNewPatientPageInsuranceSection">
                  <FormSelectField
                    name="insuranceInfo.companyName"
                    label={t('models.insuranceInfo.companyName')}>
                    <option value="" />
                    <option value="Company A">Company A</option>
                    <option value="Company B">Company B</option>
                  </FormSelectField>
                  <FormMaskField
                    name="insuranceInfo.insuranceNumber"
                    label={t('models.insuranceInfo.insuranceNumber')}
                    mask="XXX XXX XXXX"
                    replacement={{ X: /\d/ }}
                  />
                </div>
              )} */}
            </FormSection>
            <BottomBar>
              <FormSubmitButton>
                <i className="modIcon modIcon--check" /> Confirm
              </FormSubmitButton>
            </BottomBar>
          </>
        )}
      </Form>
    </Layout>
  );
}

export default NewPatientPage;
